export default __webpack_public_path__ + "static/Group 144869-c80b6ed919f98a53f798f456b9f00d01.png";